
export default function Security() {
  const securityFeatures = [
    {
      icon: 'ri-lock-line',
      title: '数据加密传输',
      desc: '全链路TLS加密，确保数据传输安全',
    },
    {
      icon: 'ri-shield-user-line',
      title: '主体与权限隔离',
      desc: '多租户架构，数据物理隔离与权限细粒度控制',
    },
    {
      icon: 'ri-file-list-3-line',
      title: '操作日志与留痕',
      desc: '完整记录所有操作行为，支持审计追溯',
    },
    {
      icon: 'ri-download-cloud-line',
      title: '导出行为记录',
      desc: '数据导出全程记录，防止敏感信息泄露',
    },
  ];

  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-[1200px] mx-auto">
        <h2 className="text-4xl font-bold text-gray-900 text-center mb-16">
          系统安全与稳定机制
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {securityFeatures.map((feature, index) => (
            <div
              key={index}
              className="p-8 rounded-xl border border-gray-100 bg-gray-50 hover:border-[#14B8A6]/40 hover:bg-[#F0FDFA] hover:shadow-sm transition-all group"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-white border border-gray-200 group-hover:bg-[#14B8A6]/10 group-hover:border-[#14B8A6]/30 text-gray-400 group-hover:text-[#14B8A6] transition-all mb-6">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-gray-800 mb-2">{feature.title}</h3>
              <p className="text-sm text-gray-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
